import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

import { AuthenticationService, LocalStorageService } from "@rubbl-core";

import { ConnectLeadService } from "../services/connect-lead.service";
import {
  CONNECT_AUTH_STORAGE_KEYS,
  CONNECT_PENDING_CODE_STORAGE_KEY,
  CONNECT_SESSION_STORAGE_KEY,
  CONNECT_TOKEN_STORAGE_KEY,
} from "./connect.constants";

/**
 * Connect follows the marketplace Identity session. Leftover device keys from the old
 * reserve-session / connect-token login are wiped on bootstrap and again on logout.
 */
@Injectable({
  providedIn: "root",
})
export class ConnectSessionService {
  readonly cleared$ = new Subject<void>();

  constructor(
    private authenticationService: AuthenticationService,
    private localStorageService: LocalStorageService,
    private connectLeadService: ConnectLeadService,
  ) {
    this.purgeLegacyDeviceAuth();
    this.authenticationService.registerLogoutHandler(() => this.clear());

    let hadMarketplaceSession = false;
    this.authenticationService.user$.subscribe(user => {
      const signedIn = !!(user && !user.expired && user.access_token);
      if (hadMarketplaceSession && !signedIn) {
        this.clear();
      }
      hadMarketplaceSession = signedIn;
    });
  }

  clear(): void {
    CONNECT_AUTH_STORAGE_KEYS.forEach(key => this.localStorageService.remove(key));
    this.connectLeadService.clearDeviceToken();
    this.cleared$.next();
  }

  private purgeLegacyDeviceAuth(): void {
    this.localStorageService.remove(CONNECT_SESSION_STORAGE_KEY);
    this.localStorageService.remove(CONNECT_TOKEN_STORAGE_KEY);
    this.localStorageService.remove(CONNECT_PENDING_CODE_STORAGE_KEY);
  }
}
